/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type FetchOrderQueryVariables = Types.Exact<{
	orderId: Types.Scalars["ID"];
}>;

export type FetchOrderQuery = {
	__typename?: "Query";
	fetchOrder: {
		__typename?: "Order";
		orderId: string;
		status: Types.OrderStatus;
		type: Types.OrderType;
		fiatId: string;
		assetId?: string | null;
		failedReason?: string | null;
		price: { __typename?: "CurrencyAmount"; value: string };
		amount: { __typename?: "CurrencyAmount"; value: string };
		createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		failedAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
		executedAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
	};
};

export const FetchOrderDocument = gql`
	query fetchOrder($orderId: ID!) {
		fetchOrder(orderId: $orderId) {
			orderId
			status
			type
			fiatId
			assetId
			price {
				value
			}
			amount {
				value
			}
			createdAt {
				iso8601
				unixTimestamp
			}
			failedAt {
				iso8601
				unixTimestamp
			}
			executedAt {
				iso8601
				unixTimestamp
			}
			failedReason
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class FetchOrderGQLService extends Apollo.Query<FetchOrderQuery, FetchOrderQueryVariables> {
	document = FetchOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
